import { useOnboardingPeriodAnalytics } from './useOnboardingPeriodAnalytics';

export type CarrierLink =
  'provider_search' | 'drug_search' | 'phone' | 'benefits_summary';

type Params = {
  onboardingPeriodId: string;
  snapshotId: string | null;
  place: 'review' | 'full_details' | 'compare';
  planId?: string | null;
};

type TrackCarrierLinkClick = (
  link: CarrierLink,
  planId?: string | null
) => void;

export function useCarrierLinkClickedEvent({
  onboardingPeriodId,
  snapshotId,
  place,
  planId: defaultPlanId,
}: Params): TrackCarrierLinkClick {
  const { track } = useOnboardingPeriodAnalytics(onboardingPeriodId);

  return (link, planId = defaultPlanId) =>
    track('carrier_link_clicked', {
      snapshot_id: snapshotId,
      plan_id: planId ?? null,
      link,
      place,
    });
}
